export const carouselPrincipal = [
  {
    img: "/images/slider/app.jpg",
    link: "#appRow",
  },
  {
    img: "/images/slider/planes.jpg",
    link: "https://store.autoprana.com.ar/react/#/planes",
  },
  {
    img: "/images/slider/usados.jpg",
    link: "https://store.autoprana.com.ar/usdS4k.php",
  },
  {
    img: "/images/slider/kinto.jpg",
    link: "https://www.kinto-mobility.com.ar/",
  },
  {
    img: "/images/slider/accesorios.jpg",
    link: "https://store.autoprana.com.ar/accS4k.php",
  },
];

export const carouselSecundario = [
  {
    img: "/images/slider/sliderSecun/hilux.png",
    modelo: "Hilux",
    url: "hilux",
    position: "8",
  },
  {
    img: "/images/slider/sliderSecun/yaris.png",
    modelo: "Yaris",
    url: "yaris",
    position: "2",
  },
  {
    img: "/images/slider/sliderSecun/corollaSport.png",
    modelo: "Corolla GR-Sport",
    url: "corollagr-sport",
    position: "5",
  },
  {
    img: "/images/slider/sliderSecun/hiace.png",
    modelo: "Hiace Furgón",
    url: "hiacefurgon",
    position: "9",
  },
  {
    img: "/images/slider/sliderSecun/sw4.png",
    modelo: "SW4",
    url: "sw4",
    position: "15",
  },
  {
    img: "/images/slider/sliderSecun/corolla.png",
    modelo: "Corolla",
    url: "corolla",
    position: "4",
  },
];
